/**
 * Donut chart
 */
export default class DonutChart {
	constructor() {
		/**
		 * DOM Selectors
		 * @type {{acceptAllLabel: string, donutChart: string, acceptLabel: string}}
		 */
		this.DOM = {
			donutChart: ".c-donut-charts",
		};

		this.donutChart = document.querySelector(this.DOM.donutChart);
	}

	/**
	 * Init
	 */
	init() {
		if (this.donutChart === null) {
			return;
		}
		this.donutCharts();
	}

	/**
	 * Animate Donut charts
	 */
	donutCharts() {
		var charts = document.getElementsByClassName('c-donut-chart__chart');

		for (var i = 0; i < charts.length; i++) {
			var val = parseInt(charts[i].getAttribute('data-percent'), 10);
			var brojka = 282 * (val / 100);
			charts[i].getElementsByClassName('c-donut-chart__orange')[0].setAttribute("style", 'stroke-dashoffset:' + brojka + ';');
		}
	}
}
